(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anchored-content"] && !Shopify.designMode) return;
  try {
    
  class AnchoredContentSection {
    constructor(container) {
      this.container = container;
      this.nav = container.querySelector('[data-anchored-nav]');
      this.blocks = container.querySelectorAll('[data-block-id]');
      this.links = container.querySelectorAll('[data-anchor-link]');
      this.sectionTop = 0;
      this.sectionBottom = 0;
      this.isSticky = false;
      
      this.init();
    }

    init() {
      if (!this.nav || this.blocks.length === 0) return;

      this.setupScrollListener();
      this.setupClickListeners();
      this.updateSectionBounds();
      
      // Update bounds on resize
      window.addEventListener('resize', () => this.updateSectionBounds());
    }

    updateSectionBounds() {
      const rect = this.container.getBoundingClientRect();
      this.sectionTop = rect.top + window.pageYOffset;
      this.sectionBottom = this.sectionTop + rect.height;
    }

    setupScrollListener() {
      let ticking = false;

      const handleScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            this.onScroll();
            ticking = false;
          });
          ticking = true;
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
    }

    onScroll() {
      const scrollPos = window.pageYOffset;
      const navHeight = this.nav.offsetHeight;
      
      // Check if we're within the section bounds
      const shouldBeSticky = scrollPos >= this.sectionTop && scrollPos < (this.sectionBottom - navHeight);
      
      if (shouldBeSticky !== this.isSticky) {
        this.isSticky = shouldBeSticky;
        this.nav.classList.toggle('is-sticky', shouldBeSticky);
      }

      // Update active link based on scroll position
      if (this.isSticky) {
        this.updateActiveLink(scrollPos + navHeight + 100);
      }
    }

    updateActiveLink(scrollPos) {
      let activeBlock = null;

      // Find the current block in view
      this.blocks.forEach(block => {
        const rect = block.getBoundingClientRect();
        const blockTop = rect.top + window.pageYOffset;
        
        if (scrollPos >= blockTop) {
          activeBlock = block;
        }
      });

      // Update active state on links
      if (activeBlock) {
        const activeId = activeBlock.dataset.blockId;
        
        this.links.forEach(link => {
          const isActive = link.dataset.anchorLink === activeId;
          link.classList.toggle('is-active', isActive);
          
          // Scroll the active link into view if needed
          if (isActive) {
            this.scrollLinkIntoView(link);
          }
        });
      }
    }

    scrollLinkIntoView(link) {
      const scrollWrapper = this.nav.querySelector('.anchored-nav__scroll-wrapper');
      const linkRect = link.getBoundingClientRect();
      const wrapperRect = scrollWrapper.getBoundingClientRect();
      
      if (linkRect.left < wrapperRect.left) {
        scrollWrapper.scrollLeft -= (wrapperRect.left - linkRect.left) + 20;
      } else if (linkRect.right > wrapperRect.right) {
        scrollWrapper.scrollLeft += (linkRect.right - wrapperRect.right) + 20;
      }
    }

    setupClickListeners() {
      this.links.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = link.getAttribute('href');
          const targetElement = document.querySelector(targetId);
          
          if (targetElement) {
            const navHeight = this.nav.offsetHeight;
            const targetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - navHeight - 20;
            
            window.scrollTo({
              top: targetTop,
              behavior: 'smooth'
            });
          }
        });
      });
    }
  }

  // Initialize all anchored content sections
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.anchored-content-section').forEach(section => {
      new AnchoredContentSection(section);
    });
  });

  // Reinitialize on Shopify theme editor events
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.anchored-content-section');
      if (section) {
        new AnchoredContentSection(section);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
